import { Box, Container, Tab, Tabs, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { useEffect, useMemo, useState } from 'react'
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom'

import { Autocomplete } from '@/components/auto-complete'
import { useAuth } from '@/hooks/use-auth'
import { useCompanies } from '@/hooks/use-companies'
import { usePrivateRoutes } from '@/hooks/use-private-routes'
import { defaultRoute } from '@/routes/config'

import AccountModal from './account-modal'
import HelpCenter from './help-center'
import { useStyles } from './styles'

const HiddenTab = styled(Tab)({
  visibility: 'hidden',
  position: 'absolute',
  left: -1000,
  width: 1,
  height: 1,
  overflow: 'hidden',
})

const NavBar = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()
  const {
    selectedCompany,
    companies,
    selectCompanyById,
    isCompaniesError,
    isCompaniesLoading,
  } = useCompanies()
  const privateRoutes = usePrivateRoutes()

  const [currentIndexRoute, setCurrentIndexRoute] = useState(0)

  const sortedCompanies = useMemo(
    () => companies.sort((a, b) => -b.group.localeCompare(a.group)),
    [companies],
  )

  const filteredRoutes = useMemo(
    () =>
      privateRoutes
        ?.flatMap((route) => ('Wrapper' in route ? route.routes : route))
        .filter((route) => route?.name),
    [privateRoutes],
  )

  const handleTabs = (_event: React.ChangeEvent<any>, value: number) => {
    return (
      filteredRoutes &&
      navigate(filteredRoutes[value].to || filteredRoutes[value].path)
    )
  }

  useEffect(() => {
    const currentRoute = filteredRoutes?.findIndex((route) =>
      matchPath(`${route.path}/*`, location.pathname),
    )

    if (currentRoute !== undefined) setCurrentIndexRoute(currentRoute)
  }, [location, filteredRoutes])

  return (
    <Container component='nav' maxWidth='xl'>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        height='7.2rem'
        gridGap='5rem'
      >
        <Link className={classes.logo} to={defaultRoute()}>
          <img
            src='assets/img/atlas-logo-no-shadow.svg'
            alt='Logo do Cromai Atlas'
          />
          <Typography variant={'h1'}>Cromai Atlas</Typography>
        </Link>

        {filteredRoutes && (
          <Tabs
            className={classes.tabs}
            value={currentIndexRoute}
            onChange={handleTabs}
            variant='scrollable'
            indicatorColor='primary'
            textColor='secondary'
          >
            {filteredRoutes.map((route) => (
              <Tab label={route.name} key={route.path} />
            ))}
            <HiddenTab value={-1} />
          </Tabs>
        )}
        <div className={classes.rightContent}>
          <HelpCenter />
          <div className={classes.buttons}>
            {!isCompaniesLoading && !isCompaniesError && (
              <Autocomplete
                id='select-company'
                options={sortedCompanies}
                groupBy={(data) => data.group}
                getOptionLabel={(data) => data.name}
                value={selectedCompany}
                onChange={(_, newValue: any) =>
                  newValue && selectCompanyById(newValue.id)
                }
                getOptionSelected={(data, value) => data.id === value.id}
                noOptionsText={
                  <Box
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                  >
                    <Typography variant='subtitle2'>
                      Nenhum resultado encontrado.
                    </Typography>
                    <Typography variant='subtitle1'>
                      Por favor, pesquise outro termo.
                    </Typography>
                  </Box>
                }
                classes={{ listbox: classes.listbox }}
              />
            )}
            <AccountModal user={user} />
          </div>
        </div>
      </Box>
    </Container>
  )
}
export default NavBar
